import useSWR from 'swr';

import { getAllServices, getServiceById } from './servicesService';
import { useServicesStore } from './servicesStore';

export function useServices() {
	const { setServices } = useServicesStore();

	const { mutate, ...rest } = useSWR('services', getAllServices, {
		revalidateOnFocus: true,
		revalidateOnReconnect: true,
		revalidateOnMount: true,
		onSuccess: (services) => {
			setServices(services);
		},
	});

	return {
		getServices: mutate,
		...rest,
	};
}

export function useServicesByIds() {
	const { setServicesByIds } = useServicesStore();

	const { mutate, isValidating, ...rest } = useSWR('servicesByIds', null, {
		revalidateOnFocus: true,
		revalidateOnReconnect: true,
		revalidateOnMount: true,
	});

	const fetchServicesByIds = async (ids: string[]) => {
		const result = await getServiceById(ids);

		setServicesByIds(result);
		await mutate(result, false);

		return result;
	};

	return { ...rest, fetchServicesByIds, isLoading: isValidating };
}
